var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { usePrevious } from '../utils/helpers';
export default React.memo(function (props) {
    var cityName = props.cityName, coords = props.coords, setMapCenter = props.setMapCenter, setWikiCoords = props.setWikiCoords, geoResultsI = props.geoResultsI;
    var _a = useState(0), page = _a[0], setPage = _a[1];
    var _b = useState(false), returnError = _b[0], setReturnError = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState([]), wikiResults = _d[0], setWikiResults = _d[1];
    var prevPage = usePrevious(page);
    var prevCityName = usePrevious(cityName);
    var prevGeoResultsI = usePrevious(geoResultsI);
    var mountedRef = useRef(true);
    // const [returnError, setReturnError] = useState(false)
    var getWikiData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, data, cloned, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    setIsLoading(true);
                    return [4 /*yield*/, fetch("https://en.wikipedia.org/w/api.php?action=query&origin=*&prop=coordinates|extracts&exchars=530&exintro=true&generator=geosearch&ggsradius=10000&ggscoord=".concat(coords[geoResultsI].lat, "|").concat(coords[geoResultsI].lon, "&formatversion=2&format=json"))];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    return [4 /*yield*/, data.query];
                case 3:
                    if ((_a.sent()) && data.query.pages.length > 1) {
                        cloned = data.query.pages.map(function (_a) {
                            var title = _a.title, pageid = _a.pageid, coordinates = _a.coordinates;
                            return ({
                                display_name: title,
                                place_id: pageid,
                                lat: coordinates[0].lat,
                                lon: coordinates[0].lon,
                            });
                        });
                        if (!mountedRef.current)
                            return [2 /*return*/, null];
                        setWikiResults(data.query.pages);
                        setWikiCoords(cloned); // for map
                    }
                    else {
                        setWikiResults([]);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.log("Something went wrong: ".concat(error_1));
                    setReturnError(true);
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/, null];
            }
        });
    }); }, [coords, geoResultsI, setWikiCoords]);
    useEffect(function () {
        if (coords && coords.length > 0) {
            mountedRef.current = true;
            getWikiData();
        }
        return function () {
            mountedRef.current = false;
        };
    }, [getWikiData, coords]);
    useEffect(function () {
        if ((cityName &&
            page !== 0 &&
            prevPage !== page &&
            prevCityName !== cityName) ||
            (prevGeoResultsI !== undefined && prevGeoResultsI !== geoResultsI)) {
            setPage(0); // reset on painting change
        }
    }, [cityName, geoResultsI, page, prevCityName, prevGeoResultsI, prevPage]);
    useEffect(function () {
        if (page > -1 && wikiResults && wikiResults.length > 0) {
            setMapCenter(wikiResults[page].coordinates[0]);
            setIsLoading(false);
        }
        return function () {
            mountedRef.current = false;
        };
    }, [page, setMapCenter, wikiResults]);
    return (_jsx("div", __assign({ className: "wiki" }, { children: wikiResults && wikiResults.length > 0 && isLoading === false ? (_jsx("div", { children: _jsxs("div", __assign({ className: "wiki__results" }, { children: [_jsxs("div", __assign({ className: "label__title row" }, { children: [_jsxs("p", { children: [_jsx("span", __assign({ className: "green" }, { children: cityName })), " addresses from OpenStreetMaps", ' '] }), _jsxs("p", { children: ["Address #", geoResultsI + 1, ":", ' ', _jsx("span", __assign({ className: "blue" }, { children: coords[geoResultsI].display_name }))] })] })), _jsxs("span", __assign({ className: "label__title row" }, { children: [_jsx("span", __assign({ className: "red" }, { children: "Wikipedia" })), " articles found around", ' ', _jsxs("span", __assign({ className: "blue" }, { children: ["address #", geoResultsI + 1] })), _jsx("br", {}), " Article #", page + 1, ': ', _jsx("span", __assign({ className: "red" }, { children: wikiResults[page].title }))] })), _jsxs("div", __assign({ className: "page" }, { children: [page + 1, " of ", wikiResults.length, _jsx("br", {}), _jsx("button", __assign({ type: "button", className: "prev", onClick: function () { return setPage(page - 1); }, disabled: page === 0 }, { children: "previous" })), ' ', "|", ' ', _jsx("button", __assign({ type: "button", className: "next", onClick: function () { return setPage(page + 1); }, disabled: page === wikiResults.length - 1 }, { children: "next" }))] })), _jsx("div", { dangerouslySetInnerHTML: { __html: wikiResults[page].extract } }), _jsx("br", {}), _jsxs("a", __assign({ className: "wiki__link row", href: "https://en.wikipedia.org/?curid=".concat(wikiResults[page].pageid) }, { children: [wikiResults[page].title, " on wikipedia"] }))] })) })) : (_jsx("div", { children: _jsxs("div", __assign({ className: "render-coontainer" }, { children: [returnError && (_jsx("div", __assign({ className: "search-error" }, { children: "ERROR: something went wrong" }))), isLoading ? (_jsx("div", __assign({ className: "painting flx-ctr" }, { children: _jsx("div", { children: _jsx("svg", __assign({ className: "loading", viewBox: "25 25 50 50" }, { children: _jsx("circle", { cx: "50", cy: "50", r: "20" }) })) }) }))) : (_jsxs("div", __assign({ className: "no-results" }, { children: [cityName, " did not return any results"] })))] })) })) })));
});
